// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import notification from 'antd/lib/notification';
// APOLLO
import { graphql } from 'react-apollo';
import CREATE_SESSION from 'ApolloClient/Mutations/createSession';
import GET_SESSIONS_BY_CLIENT_ID from 'ApolloClient/Queries/sessionsByClientId';
import GET_SESSIONS from 'ApolloClient/Queries/sessions';

// COMPONENTS
import SessionForm from '../SessionForm';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

class CreateSessionForm extends React.Component {
  state = {
    loading: false,
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    this.enableBtn();
    // Pass event up to parent component
    onCancel();
  };

  /* handleSubmit = async (session, form) => {
    const { createSession, onComplete, clientId } = this.props;

    // this.disableBtn();
    this.setState({
      loading: true,
    });

    const variables = { params: Object.assign({}, session) };

    const refetchQueries = [];

    // if clientId exists, we want to refresh that client's sessions table,
    // if no client exists, we just want to refresh our session in general
    if (clientId) {
      refetchQueries.push({
        query: GET_SESSIONS_BY_CLIENT_ID,
        variables: { _id: clientId },
      });
    } else {
      refetchQueries.push({ query: GET_SESSIONS });
    }

    // call mutation to create a session
    console.log('call mutation to create a session');
    let res;

    try {
      res = await createSession({ variables, refetchQueries });
    } catch (exc) {
      this.setState({ loading: false });
      return ErrorHelpers.handleError(exc);
    }

    this.setState({
      loading: false,
    });

    notification.success({ message: 'Session successfully added!' });
    this.sessionform.resetFields();
    // Pass event up to parent component
    console.log(res.data.createSession);
    onComplete(res.data.createSession);
    // this.enableBtn();
  }; */

  handleCreation = async session => {
    let res;

    // this.disableBtn();
    this.setState({
      loading: true,
    });

    console.log('session', session);

    const variables = { params: Object.assign({}, session) };

    const refetchQueries = [];

    // if clientId exists, we want to refresh that client's sessions table,
    // if no client exists, we just want to refresh our session in general
    if (this.props.clientId) {
      refetchQueries.push({
        query: GET_SESSIONS_BY_CLIENT_ID,
        variables: { _id: this.props.clientId },
      });
    } else {
      refetchQueries.push({ query: GET_SESSIONS });
    }

    try {
      res = await this.props.createSession({ variables, refetchQueries });
    } catch (exc) {
      console.log(exc);
      this.setState({ loading: false });
      return ErrorHelpers.handleError(exc);
    }

    this.setState({
      loading: false,
    });

    notification.success({ message: 'Session successfully added!' });
    this.props.onComplete(res.data.createSession);
  };

  handleSubmit = values => {
    console.log(values);
    this.handleCreation(values);
  };

  render() {
    const { hideClientInput, clientId } = this.props;
    const { disabled } = this.state;

    return (
      <SessionForm
        session={null}
        sessionTypes={this.props.currentUser.organization.sessionTypes}
        handleSubmit={this.handleSubmit}
        clientId={this.props.clientId}
        loading={this.state.loading}
      />
    );

    // return (
    //   <SessionForm
    //     // type="new"
    //     ref={instance => {
    //       this.sessionform = instance;
    //     }}
    //     btnLabel={!this.state.loading ? 'Add Session!' : 'Creating...'}
    //     initialValue={clientId ? { client: { _id: clientId } } : null}
    //     disabled={this.state.loading}
    //     loading={this.state.loading}
    //     sessionTypes={this.props.sessionTypes}
    //     hideClientInput={hideClientInput}
    //     onBeforeHook={this.disableBtn}
    //     onErrorHook={this.enableBtn}
    //     onSubmitHook={this.handleSubmit}
    //     onCancel={this.enableBtn}
    //   />
    // );
  }
}

CreateSessionForm.propTypes = {
  hideClientInput: PropTypes.bool,
  clientId: PropTypes.string,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

CreateSessionForm.defaultProps = {
  hideClientInput: false,
  clientId: '',
  onComplete: () => {},
  onCancel: () => {},
};

const withMutation = graphql(CREATE_SESSION, { name: 'createSession' });

export default withMutation(CreateSessionForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreateSessionForm/index.js